export const formatNumberBR = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR");
};

export const formatBRL = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";

  return n.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
